"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.Wrapper = exports.OptionsWrapper = exports.MenuItemList = exports.IllustrationWrapper = exports.IllustrationOverlay = exports.HeaderWrapper = exports.DropdownWrapper = exports.ButtonStyle = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const MenuItemList = exports.MenuItemList = /*#__PURE__*/(0, _base.default)("ul", process.env.NODE_ENV === "production" ? {
  target: "e1gmqg4h6"
} : {
  target: "e1gmqg4h6",
  label: "MenuItemList"
})(process.env.NODE_ENV === "production" ? {
  name: "1ihnvmw",
  styles: "display:flex;flex-flow:wrap;margin-block-start:0;margin-block-end:0;list-style-type:none;padding-inline-start:0;>li{list-style:none;}"
} : {
  name: "1ihnvmw",
  styles: "display:flex;flex-flow:wrap;margin-block-start:0;margin-block-end:0;list-style-type:none;padding-inline-start:0;>li{list-style:none;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const styles = exports.styles = {
  default: /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:column;justify-content:flex-end;flex-wrap:wrap;position:relative;padding:1em;padding-left:2.5em;@media screen and (max-width: ", _breakpoints.default.medium, "){padding-left:1em;}" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  darkTheme: (theme, pb) => /*#__PURE__*/(0, _react.css)("background:", theme.submenuColor, ";padding-top:2em;padding-bottom:", pb, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:darkTheme;")),
  lightTheme: theme => /*#__PURE__*/(0, _react.css)("min-height:calc(171px - 2em);max-height:calc(171px - 2em);background:linear-gradient(\n          rgba(255, 255, 255, 0.65),\n          rgba(255, 255, 255, 0.65)\n        ),linear-gradient(\n          ", theme.customIllustrationColor, ",\n          ", theme.customIllustrationColor, "\n        );&>span{z-index:2;}@media screen and (max-width: ", _breakpoints.default.medium, "){min-height:calc(136px - 2em);max-height:calc(136px - 2em);overflow:unset;}" + (process.env.NODE_ENV === "production" ? "" : ";label:lightTheme;"))
};
const IllustrationWrapper = exports.IllustrationWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1gmqg4h5"
} : {
  target: "e1gmqg4h5",
  label: "IllustrationWrapper"
})("position:absolute;bottom:-4px;right:2em;z-index:0;height:150px;svg{height:150px!important;}@media screen and (max-width: ", _breakpoints.default.medium, "){height:100px;width:170px;bottom:1em;right:1em;svg{height:100px!important;}}");
const DropdownWrapper = exports.DropdownWrapper = /*#__PURE__*/(0, _base.default)("nav", process.env.NODE_ENV === "production" ? {
  target: "e1gmqg4h4"
} : {
  target: "e1gmqg4h4",
  label: "DropdownWrapper"
})("display:grid;position:relative;width:100%;z-index:1;overflow:unset;@media screen and (max-width: ", _breakpoints.default.medium, "){margin-top:1em;}");
const ButtonStyle = (theme, dark) => /*#__PURE__*/(0, _react.css)("background-color:", dark ? theme.submenuItemColor : 'white', ";color:", dark ? theme.submenuTextColorActive : 'black', ";border-color:transparent;box-shadow:0 2px 4px 0 rgba(9, 28, 68, 0.2);border-radius:", dark ? '4px' : '19px', ";height:38px;justify-content:space-between;padding:0 1em;svg,polygon{fill:", dark ? theme.submenuTextColorActive : 'black', "!important;}&:hover,&:focus,&:active{background-color:", dark ? theme.submenuItemColor : 'white', ";color:", dark ? theme.submenuTextColorActive : 'black', ";border-color:transparent;}" + (process.env.NODE_ENV === "production" ? "" : ";label:ButtonStyle;"));
exports.ButtonStyle = ButtonStyle;
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("nav", process.env.NODE_ENV === "production" ? {
  target: "e1gmqg4h3"
} : {
  target: "e1gmqg4h3",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1q5fqf9",
  styles: "display:flex;flex-direction:row;flex-wrap:wrap;margin-top:1em;margin-left:-1em;z-index:1;button:not(:last-of-type){margin-right:3px;}"
} : {
  name: "1q5fqf9",
  styles: "display:flex;flex-direction:row;flex-wrap:wrap;margin-top:1em;margin-left:-1em;z-index:1;button:not(:last-of-type){margin-right:3px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const OptionsWrapper = exports.OptionsWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1gmqg4h2"
} : {
  target: "e1gmqg4h2",
  label: "OptionsWrapper"
})(props => /*#__PURE__*/(0, _react.css)("position:absolute;left:0;right:0;min-width:150px;box-shadow:0px 10px 15px 0px rgba(0, 0, 0, 0.1);z-index:1000;border-radius:", props.lightTheme ? '19px' : '4px', ";overflow:hidden;top:40px;padding-inline-start:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:OptionsWrapper;")));
const HeaderWrapper = exports.HeaderWrapper = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1gmqg4h1"
} : {
  target: "e1gmqg4h1",
  label: "HeaderWrapper"
})("margin-left:-0.1em;@media screen and (max-width: ", _breakpoints.default.medium, "){font-size:22px;}");
const IllustrationOverlay = exports.IllustrationOverlay = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1gmqg4h0"
} : {
  target: "e1gmqg4h0",
  label: "IllustrationOverlay"
})(process.env.NODE_ENV === "production" ? {
  name: "rkhdk1",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;z-index:0;overflow:hidden;pointer-events:none"
} : {
  name: "rkhdk1",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;z-index:0;overflow:hidden;pointer-events:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});